<div><img src="../../../assets/img/ibex-logo-text-new-new.png"/></div>

<p *ngIf="this.type === 'activate_password_credential'">{{'login.reset.activateAccount' | translate}}</p>
<p *ngIf="this.type === 'reset_password_credential'">{{'login.reset.resetAccount' | translate}}</p>

<div>
  <mat-form-field>
    <input [(ngModel)]="email" disabled matInput name="email" placeholder="{{'login.email' | translate}}">
  </mat-form-field>
  <password-confirm (validation)="onPasswordValidatiton($event)"></password-confirm>
</div>

<p>
  <button (click)="resetPassword()" [disabled]="!password" color="primary"
          mat-raised-button>{{'login.reset.register' | translate}}
  </button>
</p>

<button (click)="navigateToLogin()" *ngIf="this.type === 'reset_password_credential'" mat-button>{{'login.reset.back' | translate}}</button>
